










import Vue from 'vue'
import Component from 'vue-class-component'
import Header from './components/Header.vue'
import BasePage from '@/components/layout/BasePage.vue'

@Component({
  components: {
    BasePage,
    Header
  }
})
export default class Mirror extends Vue {
  beforeCreate () {
    this.$mirrorWebsocket.init()
  }
  beforeUnmount () {
    this.$mirrorWebsocket.close()
  }
}
